import { render } from "./SentDocumentsView.vue?vue&type=template&id=22ad8c33"
import script from "./SentDocumentsView.vue?vue&type=script&lang=js"
export * from "./SentDocumentsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__